export default "__VITE_ASSET__aJirjvWp__"